export default __webpack_public_path__ + "static/media/Michael_Jackson_0004.b6e1306e.jpg";